/** The four teacher-rating levels shown on the meeting detail views (1–4). */
export interface RatingLevel {
  rating: number;
  labelKey: string;
  /** Base Font Awesome name, resolved with `toDuotoneIcon(..., "solid")` at render time. */
  icon: string;
  /** Filled circular-badge classes applied when this level is the given rating. */
  activeBoxClass: string;
  activeIconClass: string;
  /** Background of this level's segment in MeetingProgressBar. */
  barColorClass: string;
}

export const RATING_LEVELS: RatingLevel[] = [
  {
    rating: 1,
    labelKey: "pages.studentMyFeedback.rating.excellent",
    icon: "fa-graduation-cap",
    activeBoxClass: "tw-bg-blue-200 tw-border tw-border-blue-300 tw-shadow-xs",
    activeIconClass: "tw-text-blue-500",
    barColorClass: "tw-bg-blue-500",
  },
  {
    rating: 2,
    labelKey: "pages.studentMyFeedback.rating.keepGoing",
    icon: "fa-thumbs-up",
    activeBoxClass:
      "tw-bg-green-200 tw-border tw-border-green-300 tw-shadow-xs",
    activeIconClass: "tw-text-green-500",
    barColorClass: "tw-bg-green-500",
  },
  {
    rating: 3,
    labelKey: "pages.studentMyFeedback.rating.watchOut",
    icon: "fa-hand-point-up",
    activeBoxClass:
      "tw-bg-yellow-200 tw-border tw-border-yellow-300 tw-shadow-xs",
    activeIconClass: "tw-text-yellow-500",
    barColorClass: "tw-bg-yellow-500",
  },
  {
    rating: 4,
    labelKey: "pages.studentMyFeedback.rating.beCareful",
    icon: "fa-hexagon-exclamation",
    activeBoxClass: "tw-bg-red-200 tw-border tw-border-red-300 tw-shadow-xs",
    activeIconClass: "tw-text-red-500",
    barColorClass: "tw-bg-red-500",
  },
];
